export default __webpack_public_path__ + "static/media/birthday-cake.5e6b41b6.png";